import $ from 'jquery';
$(function () {
    let query = '';
    let toolTipResults;
    $('.article-content__main-body span.toolTip').each((index, element) => {
        query += 'toolTipNames=' + $(element).text() + '&';
    });

    if (query) {
        $.get('/api/ToolTip/GetToolTips?' + query, function (data) {
            toolTipResults = data;
            $('.article-content__main-body span.toolTip').each(
                (index, element) => {
                    const toolTipDescription = searchToolTips(
                        element.textContent
                    );
                    if (toolTipDescription) {
                        $(element).attr('title', toolTipDescription);
                        $(element).attr('data-toggle', 'tooltip');
                        $(element).attr('data-html', 'true');
                        $(element).attr('data-placement', 'top');
                        $(element).attr(
                            'data-template',
                            '<div class="tooltip tooltipSearch" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>'
                        );
                        $(element).addClass('active');
                    }
                }
            );
            // To ensure tooltips are shown
            $('[data-toggle="tooltip"]').tooltip();
        });
    }

    function searchToolTips(query) {
        let result = '';
        $.each(toolTipResults, (index, element) => {
            result = '';
            if (element.name.toLowerCase() === query.toLowerCase()) {
                result = element.detail;
                return false;
            }
        });
        return result;
    }
});
